import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import { setConfig } from '../actions/config'
import '../css/elements/backdrops.css'
class Backdrops extends Component {
  constructor () {
    super()
    this.handleToggleBackdrop = this.handleToggleBackdrop.bind(this)
  }

  handleToggleBackdrop () {
    this.props.setConfig('rightSidebar', !this.props.rightSidebar)
  }

  render () {
    if (this.props.config.layout === 'empty-view-1') {
      return (
        <div />
      )
    }
    return (
      <div
        className={
          this.props.rightSidebar
            ? 'right-sidebar-backdrop fade in'
            : 'right-sidebar-backdrop'
        }
        onClick={this.handleToggleBackdrop}
      />
    )
  }
}
const mapStateToProps = ({ config }, ownProps) => ({ config, rightSidebar: config.rightSidebar })
const mapDispatchToProps = dispatch => ({
  setConfig: (key, value) => dispatch(setConfig(key, value))
})
export default connect(mapStateToProps, mapDispatchToProps)(Backdrops)



// WEBPACK FOOTER //
// ./src/elements/Backdrops.js